export default {
  id: 'notesAndSummaries/DISCHARGE/v1',
  formSchema: {
    title: 'encounter:widget.notesAndSummaries.discharge',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.notesAndSummaries.discharge',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
